import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { FormStateService } from 'src/app/core/services/form-state.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<any> {
  constructor(private formService: FormStateService) {}
  canDeactivate(): boolean {
    if (this.formService.getFormState()) {
      return confirm('Souhaitez-vous abandonner la saisie de la demande ? Vos données saisies ne seront pas enregistrées.');
    }
    return true;
  }
}
